// Integrations offered to customers. Paid ones (Xero, SkySlope) are paused until
// paying clients or investment cover them. Their code stays: add the key back
// here (and in the backend's ENABLED_ACCOUNTING_PROVIDERS / ENABLED_DEAL_SOURCES)
// to restore them.
export const ENABLED_ACCOUNTING_PROVIDERS = ['quickbooks'];
export const ENABLED_DEAL_SOURCES = ['lone_wolf'];

const onlyEnabled = (list, enabled) => (list || []).filter((x) => enabled.includes(x?.key));

/** Books payload with only the accounting providers we offer. */
export function visibleBooks(data) {
  if (!data || typeof data !== 'object') return data;
  const conn = data.connection && !ENABLED_ACCOUNTING_PROVIDERS.includes(data.connection.provider) ? null : data.connection;
  return { ...data, providers: onlyEnabled(data.providers, ENABLED_ACCOUNTING_PROVIDERS), connection: conn ?? null };
}

/** Deal import payload with only the deal sources we offer. */
export function visibleImport(data) {
  if (!data || typeof data !== 'object') return data;
  const conn = data.connection && !ENABLED_DEAL_SOURCES.includes(data.connection.source) ? null : data.connection;
  return { ...data, sources: onlyEnabled(data.sources, ENABLED_DEAL_SOURCES), connection: conn ?? null };
}
